import { PgaPolicy } from "./pga-policy.model";

export class CardProtectionPolicy extends PgaPolicy {}
